module.exports = __webpack_public_path__ + "static/media/MG.77fbbf5c.png";